import { IServices } from "@netent/origin";
import { PlayUIListenerCreator } from "../../types";

export const onGameHistoryRequest: PlayUIListenerCreator = (
  services: IServices
) => () => {
  services.game.goToHistory();
};
